import { defineMessages } from 'react-intl';
export default defineMessages({
    temperatureByChannel: {
        id: 'sensors.temperatureByChannel',
        defaultMessage: 'Temperature by channel'
    },
    viewChart: {
        id: 'sensors.viewChart',
        defaultMessage: 'View chart'
    },
    compareTemperatures: {
        id: 'sensors.compareTemperatures',
        defaultMessage: 'Compare temperatures'
    },
    compareHumidity: {
        id: 'sensors.compareHumidity',
        defaultMessage: 'Compare humidity'
    },
    pm25ByChannel: {
        id: 'sensors.pm25ByChannel',
        defaultMessage: 'PM2.5 by channel'
    },
    comparePm25: {
        id: 'sensors.comparePm25',
        defaultMessage: 'Compare PM2.5'
    },
    moistureByChannel: {
        id: 'sensors.moistureByChannel',
        defaultMessage: 'Moisture by channel'
    },
    soilTemperatureByChannel: {
        id: 'sensors.soilTemperatureByChannel',
        defaultMessage: 'Soil temperature by channel'
    },
    soilConductivityByChannel: {
        id: 'sensors.soilConductivityByChannel',
        defaultMessage: 'Conductivity by channel'
    },
    compareMoisture: {
        id: 'sensors.compareMoisture',
        defaultMessage: 'Compare moisture'
    },
    waterTensionByChannel: {
        id: 'sensors.waterTensionByChannel',
        defaultMessage: 'Soil water tension by channel'
    },
    compareWaterTension: {
        id: 'sensors.compareWaterTension',
        defaultMessage: 'Compare soil water tension'
    },
    leafWetnessByChannel: {
        id: 'sensors.leafWetnessByChannel',
        defaultMessage: 'Leaf wetness by channel'
    },
    depthByChannel: {
        id: 'sensors.depthByChannel',
        defaultMessage: 'Depth by channel'
    },
    indoorTemperatureAndHumidity: {
        id: 'sensors.indoorTemperatureAndHumidity',
        defaultMessage: 'Temperature & humidity'
    },
    indoorClimate: {
        id: 'sensors.indoorClimate',
        defaultMessage: 'Indoor climate'
    },
    indoorCo2Levels: {
        id: 'sensors.indoorCo2Levels',
        defaultMessage: 'CO2 levels'
    },
    sensorHistory: {
        id: 'sensors.sensorHistory',
        defaultMessage: 'Sensor history'
    },
    noDataAvailable: {
        id: 'sensors.noDataAvailable',
        defaultMessage: 'No data available'
    },
    sensorDetailDescription: {
        id: 'sensors.sensorDetailDescription',
        defaultMessage: 'View historical data and trends for your sensor channels.'
    },
    selectChannel: {
        id: 'sensors.selectChannel',
        defaultMessage: 'Select channel'
    },
    pm25AndAqi: {
        id: 'sensors.pm25AndAqi',
        defaultMessage: 'PM2.5 & AQI'
    },
    pm10AndAqi: {
        id: 'sensors.pm10AndAqi',
        defaultMessage: 'PM10 & AQI'
    },
    pm1AndAqi: {
        id: 'sensors.pm1AndAqi',
        defaultMessage: 'PM1.0 & AQI'
    },
    pm4AndAqi: {
        id: 'sensors.pm4AndAqi',
        defaultMessage: 'PM4.0 & AQI'
    },
    bgtSensors: {
        id: 'sensors.bgtSensors',
        defaultMessage: 'Black globe & WBGT'
    },
    heatStressNone: {
        id: 'sensors.heatStressNone',
        defaultMessage: 'No heat stress'
    },
    heatStressModerate: {
        id: 'sensors.heatStressModerate',
        defaultMessage: 'Moderate heat stress'
    },
    heatStressStrong: {
        id: 'sensors.heatStressStrong',
        defaultMessage: 'Strong heat stress'
    },
    heatStressVeryStrong: {
        id: 'sensors.heatStressVeryStrong',
        defaultMessage: 'Very strong heat stress'
    },
    heatStressExtreme: {
        id: 'sensors.heatStressExtreme',
        defaultMessage: 'Extreme heat stress'
    },
    lightningSensor: {
        id: 'sensors.lightningSensor',
        defaultMessage: 'Lightning'
    },
    strikesToday: {
        id: 'sensors.strikesToday',
        defaultMessage: 'Strikes today'
    },
    cameraFeed: {
        id: 'sensors.cameraFeed',
        defaultMessage: 'Camera'
    }
});
